import React, { useState } from "react";
import styles from "./sidebar.module.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link } from "react-router-dom";


const Sidebar = () => {
  const [select, setSelect] = useState(0);

  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={select}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { background: "transparent" } }}
      >
        <Tab
          component={Link}
          to="/attainment"
          label="ISE & MSE Data Import"
          style={{ minWidth: "100%" }}
          className={select == 0 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(0)}
        />
        {/* <Tab
          component={Link}
          to="/attainment/ise-mse-data-import"
          label="ISE & MSE Data Import"
          style={{ minWidth: "100%" }}
          className={select == 1 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(1)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/ese-data-import"
          label="ESE Data Import"
          style={{ minWidth: "100%" }}
          className={select == 2 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(2)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/co-attainment"
          label="CO Attainment (ISE & MSE)"
          style={{ minWidth: "100%" }}
          className={select == 3 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(3)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/course-co-attainment"
          label="Course-CO Attainment (ISE & MSE,ESE)"
          style={{ minWidth: "100%" }}
          className={select == 4 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(4)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/course-attainment-comparision"
          label="Course Attainment Comparison"
          style={{ minWidth: "100%" }}
          className={select == 5 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(5)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/po-attainment"
          label="PO Attainment"
          style={{ minWidth: "100%" }}
          className={select == 6 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(6)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/program-level-course"
          label="Program Level Course - PO & PSO Attainment"
          style={{ minWidth: "100%" }}
          className={select == 7 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(7)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/cay-po-attainment"
          label="CAY PO Attainment"
          style={{ minWidth: "100%" }}
          className={select == 8 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(8)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/individual-po-attainment"
          label="Individual PO Attainment(Within a Batch)"
          style={{ minWidth: "100%" }}
          className={select == 9 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(9)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/data-analysis"
          label="Data Analysis (ISE,MSE & ESE)"
          style={{ minWidth: "100%" }}
          className={select == 10 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(10)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/student-co-attainment"
          label="Student CO Attainment"
          style={{ minWidth: "100%" }}
          className={select == 11 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(11)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/student-po-attainment"
          label="Student PO Attainment"
          style={{ minWidth: "100%" }}
          className={select == 12 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(12)}
        /> */}
        {/* <Tab
          component={Link}
          to="/attainment/student-improvement-plan"
          label="student Improvement Plan (ISE & MSE,ESE)"
          style={{ minWidth: "100%" }}
          className={select == 13 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(13)}
        /> */}
      </Tabs>
    </>
  );
};

export default Sidebar;
